import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { WithStyles, createStyles, Typography, Button, Modal, Card, CardContent, CardActions, CardHeader, IconButton, FormControl, InputLabel, Select, MenuItem, Grid, Paper, Link } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import CloseIcon from '@material-ui/icons/Close';

import { MyPATCollapse, MyPATLink, dateService, MyPATDialog } from '../../common';
import ACLService from '../../acl/services/aclService'
import ContentData from '../types/ContentData';
import { getGoalList } from '../../goal-management/actions/goalManagementActions';
import { assignTest, showMsg } from "../actions/testPaperCreateAction";

import env from '../../../config/config'
import RevisionHistoryModal from './RevisionHistoryModal';
import { calCulateProgressBar, getPropertyValue } from '../../../utils';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import { CONTENT_STATUS } from '../../../constants/comman';

const styles = (theme: Theme) => createStyles({
	deleteLink: {
		cursor: 'pointer',
		marginLeft: theme.spacing.unit / 2,
	},
	progressContainer: {
		paddingBottom: '5px',
	},
	fullWidth: {
		width: '100%'
	},
	progress: {
		height: '5px',
		width: '100%',
		background: theme.palette.background.default,
		borderRadius: '5px',
		display: 'block',
		'& span': {
			background: theme.palette.primary.light,
			borderRadius: '5px',
			display: 'block',
			height: '5px',
		}
	},
	progressText: {
		fontSize: '13px',
		opacity: 0.7,
		marginBottom: '6px',
	},
	keyValueContainer: {
			display: 'flex',
			margin: '10px 0',
			fontSize: '14px',
			'&>p:nth-of-type(1)':{
				fontWeight: 700,
	
			}
	},
	modal: {
		display: 'flex',
		padding: 12,
		alignItems: 'center',
		justifyContent: 'center',
	},
	modalHeader: {
		height: 60,
		borderBottom: 'solid 1px #0004'
	},
	paper: {
		width: 680,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: '20, 40, 30',
		textAlign: 'center',
	},
	root: {
		justifyContent: 'center'
	},
	padding2X: {
		padding: '24px 0px 24px 100px'
	},
	formControl: {
		width: 200,
		marginTop: 30,
	},
	red: {
		color: '#F21D1D'
	},
	headingFont: {
		fontSize: '1.25rem',
		fontWeight: 'bold',
		fontStyle: 'normal'
	},
	subHeadingFont: {
		fontSize: '1rem',
		fontStyle: 'normal',
		marginRight: 10,
	},
	goalTitle:{
		marginTop: 30,
		fontSize: 16,
	},
	separator: {
		borderBottom: "1px solid #DFDFDF",
	}
});

//@ts-ignore
interface PreviewPageInfoProps extends WithStyles<typeof styles> {
	classes: any,
	validations: any,
	deleteContent: () => void,
	content: ContentData,
	getGoalList: Function,
	goalList: any[],
	assignTest: Function,
	assignTestInfo: any,
	showMsg: Function,
	contentHistory: any,
	isPostExpiryDays: any,
	showLicenseExpiredDialog: any,
	toggleLicenseExpiredDialog: any,
	setLoggedInUser: any,
	requestId: string,
	contentRequestIds: any,
	showAssignTest?:boolean
}

interface PreviewPageInfoStates {
	isOpen: boolean,
	goalList: any[],
	selectedGoal: any,
	isOpenContentHistory: boolean,
}

class PreviewPageInfo extends Component<PreviewPageInfoProps, PreviewPageInfoStates>{

	constructor(props: PreviewPageInfoProps) {
		super(props);
		this.state = {
			isOpen: false,
			goalList: [],
			selectedGoal: null,
			isOpenContentHistory: false,
		}

		this.handleGoalChange = this.handleGoalChange.bind(this)
		this.handleConfirm = this.handleConfirm.bind(this)
		this.handleClose = this.handleClose.bind(this)
		this.handleOpen = this.handleOpen.bind(this)
	}

	static getDerivedStateFromProps(props: any, state: any) {
		if (props.goalList !== state.goalList) {
			const goalList = PreviewPageInfo.filterGoalList(props.goalList)
			return { goalList }
		}
	}
	componentDidMount() {
		this.props.getGoalList();
		this.props.setLoggedInUser();
	}

	componentDidUpdate(prevProps: any) {
		if (this.props.assignTestInfo != prevProps.assignTestInfo) {
			if (this.props.assignTestInfo) {
				if (this.props.assignTestInfo.teacherToken) {
					const token = this.props.assignTestInfo.teacherToken;
					const queryParams = `authToken=${token}&target=assignments&action=assignTest`;
					window.open(`${env.stakeholderURL}?${queryParams}`, '_blank');
				} else if (this.props.assignTestInfo[0].token) {
						const userInfo: any = localStorage.getItem('patmy')
						const authUser = _.get(JSON.parse(userInfo), 'authenticatedUser') || {}
						const { classId, courseId, courseItemId, testId } = this.getGoalDetails()
						let queryParams = ''
						queryParams += `authToken=${this.props.assignTestInfo[0].token}&`
						queryParams += `clientId=${authUser.clientId._id}&`
						queryParams += `classId=${classId}&`
						queryParams += `courseId=${courseId}&`
						queryParams += `courseItemId=${courseItemId}&`
						queryParams += `testId=${testId}&`
						queryParams += `source=CMS`
						window.open(`${env.watsonURL}/assignTests?${queryParams}`, "_blank");
				} else {
					this.props.showMsg('User has not been authenticated. Please connect with the administrator.', 'error')
				}
			}
		}
	}

	formatPercentage(val: any) {
		return val && !isNaN(val) ? parseInt(val) : "0"
	}

	hasDeleteAccess(content: any) {
		let status = false;
		let contentStatus = _.get(content, 'status', '');
		let permission = ['PUBLISHED'].includes(contentStatus) ? ['EDITWITHPUBLISH'] : ['DELETE'];
		status = !['DELETE'].includes(contentStatus) ? true : status;
		return status;
	}

	static filterGoalList(goalList: any) {
		return goalList.filter((goal: any) => {
			const isUpcoming = (new Date(goal.endDate).getTime() - new Date().getTime()) > 0
			const isOrgTestExist = goal.courseItems.filter((course: any) => course.itemType === 'orgTests').length > 0
			return isUpcoming && isOrgTestExist
		})
	}

	handleOpen() {
		if (this.props.isPostExpiryDays) {
			this.props.toggleLicenseExpiredDialog(true)
		} else {
			this.setState({ isOpen: true })
		}
	}

	handleClose() {
		this.setState({ isOpen: false, selectedGoal: null })
	}

	getFilteredGoalList() {
		let { goalList } = this.props
		return goalList.filter(goal => {
			const isUpcoming = (new Date(goal.endDate).getTime() - new Date().getTime()) > 0
			const isOrgTestExist = goal.courseItems.filter((course: any) => course.itemType === 'orgTests').length > 0
			return isUpcoming && isOrgTestExist
		})
	}

	handleGoalChange(e: any) {
		this.setState({
			selectedGoal: e.target.value
		})
	}

	getGoalDetails() {
		const { selectedGoal } = this.state
		const { content } = this.props
		const courseItem = (selectedGoal && selectedGoal.courseItems.find((c: any) => c.itemType === 'orgTests')) || {}
		const clazz = (selectedGoal && selectedGoal.eligibility && selectedGoal.eligibility.length > 0 && selectedGoal.eligibility[0].class) || {}
		const goalDetails = {
			courseId: selectedGoal && selectedGoal._id,
			classId: clazz.id,
			courseItemId: courseItem.id,
			testId: content.content_Id
		}
		return goalDetails
	}

	handleConfirm() {
		const goalDetails = this.getGoalDetails()
		const params = {
			courseId: goalDetails.courseId,
			courseItemId: goalDetails.courseItemId,
			testId: goalDetails.testId
		}
		this.props.assignTest({ params }) // hit api
	}

	showAssignTest() {
		const userInfo: any = localStorage.getItem('patmy')
		const authUser = _.get(JSON.parse(userInfo), 'authenticatedUser') || {}
		const { content } = this.props
		const contentId = _.get(content, 'contentId')
		const contentTypeCode = _.get(content, 'contentTypeCode')
		const status = _.get(content, 'status', '')
		if (!!authUser.isAssignTest && contentId && contentTypeCode === 'testpapers' && status.toLowerCase() === 'published' && this.props.showAssignTest === true) {
			return true
		}
		return false
	}

	toggleContentHistory = () => {
		this.setState({ isOpenContentHistory: !this.state.isOpenContentHistory });
	}

	renderCreationInfo = (creationInfo: any, isDigitizedInfo = false) => {
		const { classes } = this.props;
		return (
			<>
				{isDigitizedInfo && <div className={classes.separator}></div>}
				<div className={classes.keyValueContainer}>
					<Typography variant="body2" className={classes.subHeadingFont}>{isDigitizedInfo ? 'Digitized' : 'Created'} By: </Typography>
					<Typography variant="body1" className={classes.subHeadingFont}>{creationInfo.fullName}</Typography>
				</div>
				<div className={classes.keyValueContainer}>
					<Typography variant="body2" className={classes.subHeadingFont}>Client Name: </Typography>
					<Typography variant="body1" className={classes.subHeadingFont}>{((creationInfo.clients || []).find((client: any) => client.primary) || {}).name}</Typography>
				</div>
			</>)
	}

	checkContentStatus = () => {
		const {content} = this.props;
		if((content || {}).status === CONTENT_STATUS.DRAFT) {
			return ((((content || {}).aclMetaData || {}).createdBy || {}).id || {})._id === ((ACLService.getUserDetailsFromStorage() ||{}).authenticatedUser || {}).id
		}
		return true;
	}

	render() {
		const { classes, content, validations, deleteContent, contentHistory = [], requestId = '', contentRequestIds = [] } = this.props;
		const { goalList, selectedGoal, isOpen, isOpenContentHistory } = this.state
		const { requestIds = [] } = contentRequestIds;
		const isCreatedByEdp = (getPropertyValue(content, 'aclMetaData.digitizedBy.id.id', '') && (getPropertyValue(content, 'aclMetaData.createdBy.id.id', '') !== getPropertyValue(content, 'aclMetaData.digitizedBy.id.id', '')));
		const masterQuestionObject=_.get(content,'masterVariationQuestionData','');
		return (
			// <MyPATCollapse className={classes.subHeadingFont} title="Page Info">
			<>
				{/* {_.get(content, 'status', '') == "DRAFT" && (
					<div className={classes.progressContainer}>
						<span className={classes.progress}>
							<span style={{
								width: ((validations) ? calCulateProgressBar(validations).barPercentage
									: content.completionPercent) + '%'
							}}></span>
						</span>
						<Typography variant="subtitle2" className={classes.progressText}>
							{
								validations ? calCulateProgressBar(validations).barPercentage
									: this.formatPercentage(content.completionPercent)
							}
							% Completion
						</Typography>
					</div>
				)} */}

				<div className={classes.keyValueContainer}>
					<Typography variant="body2" className={classes.subHeadingFont}>Status: </Typography>
					<Typography variant="body1" className={classes.subHeadingFont}>
						{(getPropertyValue(content,'validationStatus','') || getPropertyValue(content, 'status', '')).toLocaleUpperCase()  }
					</Typography>
					{
						//accessType={content.status == "PUBLISHED" ? ["EDITWITHPUBLISH"] : ["EDITWITHOUTPUBLISH", "EDIT", "UPDATE"]}
						_.get(content, 'status', '') != "DELETED" && this.checkContentStatus() &&
						this.hasDeleteAccess(content) && !_.isEqual('PUBLISHED', _.get(content, 'status', '')) && (
							<Typography variant="body1"
								onClick={deleteContent}
								className={[classes.deleteLink, classes.red].join(' ')}
							>
								Delete
							</Typography>
						)}
				</div>

				<div className={classes.keyValueContainer}>
					
					<Typography variant="body2" className={classes.subHeadingFont}>
						{masterQuestionObject?'Variation ':'' }
						{(content.contentTypeCode == 'question'
							? 'Question '
							: (content.contentTypeCode == 'testpapers'
								? 'Test '
								: 'Content ')
						)}
						ID:
					</Typography>
					<MyPATLink to={`/content/preview/${content._id}`} target="_blank">
						<Typography variant="body1" color="primary" className={classes.subHeadingFont}>
							{_.get(content, 'contentId', '')}
						</Typography>
					</MyPATLink>
				</div>
				{masterQuestionObject&&<div className={classes.keyValueContainer}>
					
					<Typography variant="body2" className={classes.subHeadingFont}>
						Master {(content.contentTypeCode == 'question'
							? ' Question '
							: (content.contentTypeCode == 'testpapers'
								? ' Test '
								: ' Content ')
						)}
						ID:
					</Typography>
					<MyPATLink to={`/content/preview/${masterQuestionObject._id}question`} target="_blank">
						<Typography variant="body1" color="primary" className={classes.subHeadingFont}>
							{_.get(masterQuestionObject, 'contentId', '')}
						</Typography>
					</MyPATLink>
				</div>}
				{requestIds && Boolean(requestIds.length) && (<div className={classes.keyValueContainer}>
					<Typography variant="body2" className={classes.subHeadingFont}>
						Request ID:
					</Typography>
					<Typography variant="body1" color="primary" className={classes.subHeadingFont}>
						{_.get(contentRequestIds, 'requestIds', [] ).join(", ")}
					</Typography>
				</div>)

				}
				<div className={classes.keyValueContainer}>
					<Typography variant="body2" className={classes.subHeadingFont}>Created Date: </Typography>
					<Typography variant="body1" className={classes.subHeadingFont}>{dateService.timeDate(content.content.createdAt)}</Typography>
				</div>
				{this.renderCreationInfo(getPropertyValue(content, 'aclMetaData.createdBy.id', {}))}
				{isCreatedByEdp && this.renderCreationInfo(getPropertyValue(content, 'aclMetaData.digitizedBy.id', {}), true)}
				<div>
					{
						contentHistory.length > 0 &&
						<div>
							Revision {contentHistory.length} :
							<span>
								<Link component="button" variant="body1" underline="none" onClick={this.toggleContentHistory}>
									More
							</Link>
							</span>
						</div>
					}

					<RevisionHistoryModal
						isOpen={isOpenContentHistory}
						onClose={this.toggleContentHistory}
						contentHistory={contentHistory}
						type={content.contentTypeCode}
					/>
				</div>
				<div>
					{
						this.showAssignTest() ?
							(
								<Button className={classes.fullWidth} autoFocus
									variant="contained"
									color="primary"
									onClick={(event: React.MouseEvent<HTMLButtonElement>) => this.handleOpen()}>
									Assign Test
								</Button>
							) : null
					}

					<MyPATDialog
						dialogHeading={
							<Typography variant="h5">
								Map Test
							</Typography>
						}
						customButtonVariant="withoutBorderCloseIcon"
					    dialogHasActions={true}
						dialogOpen={isOpen}
						disablePortal
						disableEnforceFocus
						disableAutoFocus
						// open={isOpen}
						onDialogClose={(event: React.MouseEvent<HTMLButtonElement>) => this.handleClose()}
						onBackdropClick={(event: React.MouseEvent<HTMLButtonElement>) => this.handleClose()}
						// onClose={(event: React.MouseEvent<HTMLButtonElement>) => this.handleClose()}
						aria-labelledby="server-modal-title"
						aria-describedby="server-modal-description"
						className={classes.modal}
						customDialogActions={
							<>
								{/* <div classes={{ root: classes.root }}> */}
									<Button autoFocus
										variant="contained"
										color="primary"
										disabled={_.isEmpty(selectedGoal)}
										onClick={this.handleConfirm}
									>Confirm</Button>
								{/* </div> */}
							</>
						}
					>

						{/* <div className={classes.paper}> */}
							{/* <Card className={classes.root}> */}
								{/* <CardHeader className={classes.modalHeader}
									action={
										<IconButton aria-label="settings" onClick={(event: React.MouseEvent<HTMLButtonElement>) => this.handleClose()}>
											<CloseIcon fontSize="small" />
										</IconButton>
									}
									title="Map Test"
								/> */}
								<CardContent>
									<Typography className={classes.subHeadingFont} variant="body1">Kindly map this test to a target exam before assigning it to students</Typography>
									<div>
										<Grid container alignItems="center">
											<Grid item xs={6}>
												<Typography className={classes.goalTitle}>
													{_.get(content, 'content.name', '')}
												</Typography>
											</Grid>
											<Grid item xs={6}>
												<FormControl className={classes.formControl}>
													{
														!selectedGoal ? <InputLabel id="goals">Select Goal</InputLabel> : null
													}
													<Select
														id="goals-list"
														value={selectedGoal}
														name="goals"
														onChange={this.handleGoalChange}
													>
														{goalList.map((goal: any) => (
															<MenuItem key={goal._id} value={goal}>{goal.name}</MenuItem>
														))}
													</Select>
												</FormControl>
											</Grid>
										</Grid>
									</div>
								</CardContent>
								{/* <CardActions classes={{ root: classes.root }}>
									<Button autoFocus
										variant="contained"
										color="primary"
										disabled={_.isEmpty(selectedGoal)}
										onClick={this.handleConfirm}
									>Confirm</Button>
								</CardActions> */}
							{/* </Card> */}
						{/* </div> */}
					</MyPATDialog>
				</div>
			{/* </MyPATCollapse> */}
			</>
		);

	}

}

const mapStateToProps = (state: any) => ({
	goalList: _.get(state, 'goalManagement.goalManagement.list', []),
	assignTestInfo: _.get(state, "mylibraryData.content.assignTestInfo", {}),
	showLicenseExpiredDialog: state.loginData.userData && state.loginData.userData.showLicenseExpiredDialog,
	isPostExpiryDays: state.loginData.userData && state.loginData.userData.isPostExpiryDays
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	getGoalList,
	assignTest,
	showMsg,
	toggleLicenseExpiredDialog,
	setLoggedInUser
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PreviewPageInfo));

